import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class AppDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      items: {
        type: 'Schema.Union',
        types: [
          {
            type: 'Schema.Query'
          },
          {
            type: 'Schema.Variable'
          }
        ]
      },
      name: 'resources',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.Page'
      },
      name: 'pages',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.CSSStyleSheet'
      },
      name: 'stylesheets',
      type: 'Schema.Array'
    }
  ]
}
